import { getCookiesDomain, getTerminaDomain } from '@/utils/utils'

export const SUPPLIER_SHOP = 'SUPPLIER' // 供应商
export const SUPPLIER_BASE = 'SUPPLIER' // 基地/服务商
export const CHANNEL = 'CHANNEL' // 渠道

export const SUPPLIER_SHOP_OLD = 'shop' // 供应商 old key
export const SUPPLIER_BASE_OLD = 'base' // 基地/服务商 old key
export const CHANNLE_OLD = 'channel' // 渠道 old key

export const MAP = {
    [SUPPLIER_SHOP]: {
        home: getTerminaDomain(PROJECT_CONFIG.supplierTerminalName)
    },
    [SUPPLIER_BASE]: {
        home: getTerminaDomain(PROJECT_CONFIG.supplierTerminalName)
    },
    [CHANNEL]: {
        home: getTerminaDomain(PROJECT_CONFIG.channelTerminalName)
    }
}

let cookiesDomain = PROJECT_CONFIG.cookiesDomain

if (PROJECT_CONFIG.mode !== 'dev') {
    const cd = getCookiesDomain()
    cookiesDomain = `.${cd}`
}

// 获取home
export const getHome = role => {
    let roleKey = role
    switch (role) {
        case SUPPLIER_SHOP_OLD:
            roleKey = SUPPLIER_SHOP
            break
        case SUPPLIER_BASE_OLD:
            roleKey = SUPPLIER_BASE
            break
        case CHANNLE_OLD:
            roleKey = CHANNEL
            break

        default:
            roleKey = role
            break
    }
    const target = MAP[roleKey]

    if (target) {
        return target.home
    }

    return ''
}
